import badgeTokens from "./template.PrimeNG.badge.tokens";
import buttonTokens from "./template.PrimeNG.button.tokens";
import panelTokens from "./template.PrimeNG.panel.tokens";
import tieredMenuTokens from "./template.PrimeNG.tieredmenu.tokens";
import treetableTokens from "./template.PrimeNG.treetable.tokens";

/*
    To create individual component tokens, copy the tokens from the PrimeNG component page, THEMING tab
    and paste them into github copilot. Tell it:

    Format the following raw token data into a structured TypeScript object. 
    Use dot notation for nested properties,  include the variable name and description in the comments, align property names, values, and comments for readability, 
    and replace the --p- prefix in variable names with --customX-
    
    For things like buttons...
    Group severity-specific tokens (e.g., primary, secondary) into separate objects and combine them under a parent object if applicable. Ensure no duplicates and include clear comments for each token."

*/
const componentTokens = {
    // p-button
    // button: {
    //   root: {
    //     buttonTokens
    //   }
    // }
     
    treetable: treetableTokens,
    tieredmenu: tieredMenuTokens,
    button: buttonTokens,
    panel: panelTokens,
    badge: badgeTokens,
    // {  // Buttons
    //   root: buttonTokens
    //   // {
    //   //   primary: buttonTokens.primary,
    //   //   // {
    //   //   //   background: "var(--custom-button-primary-background-color) !important",
    //   //   //   color: "var(--custom-button-primary-text-color) !important",
    //   //   //   // border: "none", // No custom variable defined
    //   //   //   hover: {
    //   //   //     background: "var(--custom-button-primary-background-color) !important",
    //   //   //     color: "var(--custom-button-primary-text-hover-color) !important"
    //   //   //   },
    //   //   //   active: {
    //   //   //     background: "var(--custom-button-primary-background-color) !important",
    //   //   //     color: "var(--custom-button-primary-text-hover-color) !important"
    //   //   //   },
    //   //   //   disabled: {
    //   //   //     background: "var(--custom-button-disabled-background-color) !important",
    //   //   //     color: "var(--custom-button-disabled-text-color) !important"
    //   //   //   }
    //   //   // },
    //   //   secondary: {
    //   //     background: "var(--custom-button-secondary-background-color) !important",
    //   //     color: "var(--custom-button-secondary-text-color) !important",
    //   //     // border: "none", // No custom variable defined
    //   //     hover: {
    //   //       background: "var(--custom-button-secondary-background-color) !important",
    //   //       color: "var(--custom-button-secondary-text-color) !important"
    //   //     },
    //   //     active: {
    //   //       background: "var(--custom-button-secondary-background-color) !important",
    //   //       color: "var(--custom-button-secondary-text-color) !important"
    //   //     },
    //   //     disabled: {
    //   //       background: "var(--custom-button-disabled-background-color) !important",
    //   //       color: "var(--custom-button-disabled-text-color) !important"
    //   //     }
    //   //   }
    //   // }
    // },
  
    // p-checkbox
    checkbox: {
      checked: {
        background: "var(--custom-input-checkbox-checked-background-color)",
        hover: {
          background: "var(--custom-input-checkbox-hover-background-color)"
        },
        "border.color": "var(--custom-input-checkbox-border-color)",
        "hover.border.color": "var(--custom-input-checkbox-border-color)"
      },
      "border.color": "var(--custom-input-checkbox-border-color)",
      hoverBorderColor: "var(--custom-input-checkbox-border-color)"
    },
  
    // {
    //   // "body.cell.padding": "0", // No custom variable defined
    //   // "node.toggle.button.size": "32px" // No custom variable defined
    // },
  
    // p-card
    card: {
      colorScheme: {
        light: {
          root: {
            background: "var(--custom-panel-background-color)",
            color: "var(--custom-panel-text-color)",
            border: "1px solid var(--custom-panel-header-border-color)"
          },
          subtitle: {
            color: "var(--custom-panel-header-label-text-color)"
          }
        },
        dark: {
          root: {
            background: "var(--custom-panel-background-color)",
            color: "var(--custom-panel-text-color)",
            border: "1px solid var(--custom-panel-header-border-color)"
          },
          subtitle: {
            color: "var(--custom-panel-header-label-text-color)"
          }
        }
      }
    },
  
    // p-input
    input: {
      root: {
        background: "var(--custom-input-background-color)",
        color: "var(--custom-input-normal-text-color)",
        border: "var(--custom-input-normal-border-color)",
        hover: {
          border: "var(--custom-input-normal-hover-border-color)"
        },
        focus: {
          border: "var(--custom-input-border-focus-color)"
          // shadow: "none" // No custom variable defined
        },
        disabled: {
          background: "var(--custom-input-background-color)",
          color: "var(--custom-input-read-only-text-color)",
          border: "var(--custom-input-border-disabled)"
        }
      }
    },
  
    // p-table
    table: {
      header: {
        background: "var(--custom-table-header-default-background-color, var(--custom-table-header-background-color))",
        color: "var(--custom-table-header-default-text-color, var(--custom-table-header-text-color))",
        border: "var(--custom-table-header-default-border-color, var(--custom-table-header-border-color))"
      },
      row: {
        background: {
          default: "var(--custom-table-zebra-even-row-background-color)",
          hover: "var(--custom-table-row-hover-color)",
          selected: "var(--custom-table-selected-row-background-color)"
        },
        color: {
          default: "var(--custom-table-content-text-color)",
          hover: "var(--custom-table-content-text-color)",
          selected: "var(--custom-table-content-text-color)"
        },
        border: "var(--custom-table-row-border-color)"
      }
    },
  
    // p-modal
    modal: {
      root: {
        background: "var(--custom-dialog-background-color)",
        color: "var(--custom-dialog-text-color)"
        // border: "none", // No custom variable defined
        // shadow: "none" // No custom variable defined
      },
      overlay: {
        // background: "rgba(0, 0, 0, 0.5)" // No custom variable defined
      },
      header: {
        background: "var(--custom-dialog-info-header-background-color)",
        color: "var(--custom-dialog-info-header-text)"
      },
      footer: {
        background: "var(--custom-dialog-background-color)",
        color: "var(--custom-dialog-text-color)"
      }
    },
  
    // p-dropdown
    dropdown: {
      root: {
        background: "var(--custom-input-dropdown-item-background-color)",
        color: "var(--custom-input-dropdown-item-text-color)",
        // border: "none", // No custom variable defined
        hover: {
          background: "var(--custom-input-dropdown-hover-item-background-color)"
        },
        focus: {
          // border: "none", // No custom variable defined
          // shadow: "none" // No custom variable defined
        },
        disabled: {
          background: "var(--custom-input-dropdown-item-background-color)",
          color: "var(--custom-input-dropdown-icon-read-only-color)"
        }
      },
      item: {
        background: {
          default: "var(--custom-input-dropdown-item-background-color)",
          hover: "var(--custom-input-dropdown-hover-item-background-color)",
          selected: "var(--custom-input-dropdown-selected-item-background-color)"
        },
        color: {
          default: "var(--custom-input-dropdown-item-text-color)",
          hover: "var(--custom-input-dropdown-hover-item-text-color)",
          selected: "var(--custom-input-dropdown-selected-item-text-color)"
        }
      }
    }
  };
  
  export default componentTokens;
